var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H26C31.5228 0 36 4.47715 36 10V26C36 31.5228 31.5228 36 26 36H10C4.47715 36 0 31.5228 0 26V10Z",
    fill: "#FAF5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 15.2C12.667 14.0799 12.667 13.5198 12.885 13.092C13.0767 12.7157 13.3827 12.4097 13.759 12.218C14.1868 12 14.7469 12 15.867 12H20.1337C21.2538 12 21.8138 12 22.2416 12.218C22.618 12.4097 22.9239 12.7157 23.1157 13.092C23.3337 13.5198 23.3337 14.0799 23.3337 15.2V24L21.5003 22.6667L19.8337 24L18.0003 22.6667L16.167 24L14.5003 22.6667L12.667 24V15.2Z",
    stroke: "#9810FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillAmount);
export default __webpack_public_path__ + "static/media/billAmount.211a65ccad388e65136c27ddb94ff594.svg";
export { ForwardRef as ReactComponent };